import { CRMChannel } from "@jugl-web/rest-api";

export const WELCOME_MESSAGE_ID = "welcome";

export type ChatBotPreviewTheme = {
  headerBg: string;
  headerTextColor: string;
  headerIconColor: string;
  incomingBg: string;
  outgoingBg: string;
  outgoingNickColor: string;
  outgoingTextColor: string;
};

export const channelPreviewThemes: Record<
  Exclude<CRMChannel, CRMChannel.chatbot | CRMChannel.email | CRMChannel.voice>,
  ChatBotPreviewTheme
> = {
  whatsapp: {
    headerBg: "bg-white",
    headerTextColor: "text-dark",
    headerIconColor: "text-grey-800",
    incomingBg: "bg-white",
    outgoingBg: "bg-[#E2FFC7]",
    outgoingNickColor: "text-dark-600",
    outgoingTextColor: "text-dark",
  },

  instagram: {
    headerBg: "bg-white",
    headerTextColor: "text-dark",
    headerIconColor: "text-grey-800",
    incomingBg: "bg-[#F3F4F6]",
    outgoingBg: "bg-[linear-gradient(242deg,_#A053D3_0.31%,_#3B54C5_100.31%)]",
    outgoingNickColor: "text-grey-200",
    outgoingTextColor: "text-white",
  },

  twilio: {
    headerBg: "bg-white",
    headerTextColor: "text-dark",
    headerIconColor: "text-grey-800",
    incomingBg: "bg-grey-100",
    outgoingBg: "bg-primary-400",
    outgoingNickColor: "text-primary-50",
    outgoingTextColor: "text-white",
  },
};
